module.exports = __webpack_public_path__ + "img/18a001-04.d7dda08e.jpg";